import { Grid, Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { CheckboxEntities, FormControlLabelStyle, TypographyCheckBoxForm } from '../Entities.style'
import FlagCurrency from '../../../components/FlagCurrency/FlagCurrency'
import { ReactComponent as CheckIcon } from '../../../assets/Checkbox_checked.svg'
import TradingAccount from './components/TradingAccount'
import Traders from './components/Traders'
import { EntitySideContainer } from './EntitesSide.style'
import { useSelector } from 'react-redux'

const EntitiesSide = ({
  entity,
  entityPrimeBroker,
  traders,
  clientMmId,
  userType,
  handleClientClicked,
  handleTraderClicked
}) => {
  const entitlements = useSelector(state => state.auth.entitlements)

  const showAddNewButton = () => {
    return entitlements.includes('Static')
  }

  return (
    <EntitySideContainer item xl={3} lg={4} md={5} sm={6} className="container">
      <Grid>
        <Grid>
          <Typography style={{ color: 'white', fontSize: '24px', lineHeight: '1.25' }}>
            {entity.entity_name}
          </Typography>
        </Grid>

        <Grid style={{ display: 'flex', alignItems: 'center', marginTop: '20px', gap: '8px' }}>
          <FlagCurrency countryCode={entity.country_code} />
          <Typography
            style={{
              fontSize: '16px',
              color: '#BABEC7',
              maxWidth: '100%',
              lineHeight: '1'
            }}
          >
            {entity?.lei}
          </Typography>
        </Grid>

        <Grid
          style={{
            display: 'flex',
            marginTop: '24px',
            flexDirection: 'row',
            gap: '24px'
          }}
        >
          <FormControlLabelStyle
            name="swap_dealer"
            disabled
            checked={!!entity.swap_dealer}
            control={
              <CheckboxEntities check={String(!!entity.swap_dealer)} checkedIcon={<CheckIcon />} />
            }
            label={<TypographyCheckBoxForm>Swap Dealer</TypographyCheckBoxForm>}
            labelPlacement="end"
          />
        </Grid>
      </Grid>
      <Grid>
        <Grid style={{ margin: '32px 0px' }}>
          <TradingAccount
            entityPrimeBroker={entityPrimeBroker}
            entityName={entity.entity_name}
            handleClientClicked={handleClientClicked}
            clientMmId={clientMmId}
            userType={userType}
            showAddNewButton={showAddNewButton}
          />
          <Traders
            traders={traders}
            userType={userType}
            clientMmId={clientMmId}
            entityName={entity.entity_name}
            showAddNewButton={showAddNewButton}
            handleTraderClicked={handleTraderClicked}
          />
        </Grid>
      </Grid>
    </EntitySideContainer>
  )
}

export default EntitiesSide

EntitiesSide.propTypes = {
  entity: PropTypes.object,
  entityPrimeBroker: PropTypes.object,
  traders: PropTypes.object,
  clientMmId: PropTypes.string,
  handleClientClicked: PropTypes.func,
  handleTraderClicked: PropTypes.func,
  userType: PropTypes.string,
  form: PropTypes.object
}
